import './vendors/gsap-init';
// Include the anim-engine (wraps GSAP + ScrollTrigger) so it's bundled into the main JS bundle and executed after `gsap-init`. anim-engine is our semi-hand-rolled layer to simplify GSAP use.
import './vendors/anim-engine';

document.addEventListener('DOMContentLoaded', () => {
    const headerToggle = document.querySelector('.bb-header__toggle');
    const header = document.querySelector('.bb-header');
    const menuItems = document.querySelectorAll('.bb-header .menu .menu-item-has-children');
    const carets = document.querySelectorAll('.bb-header .menu .menu-item-has-children .caret-wrapper');

    // Helper to close all submenus
    function closeAllSubMenus() {
        menuItems.forEach(item => {
            item.classList.remove('active');
            const submenu = item.querySelector('.sub-menu');
            if (submenu) submenu.style.maxHeight = null;
            item.querySelectorAll('.caret-wrapper > *').forEach(icon => {
                icon.style.transform = 'rotate(0deg)';
            });
        });
    }

    // Close nav when any menu link is clicked
    document.querySelectorAll('#site-navigation a').forEach(link => {
        link.addEventListener('click', () => {
            headerToggle.classList.remove('nav-open');
            header.classList.remove('nav-open');
            headerToggle.setAttribute('aria-expanded', 'false');
            closeAllSubMenus();
        });
    });

    // Header scroll state — use scrollingElement.scrollTop as it reliably reflects
    // the actual scroll position regardless of which element is the scroll container.
    const scrollEl = document.scrollingElement || document.documentElement;
    const onScroll = () => header.classList.toggle('is-scrolled', scrollEl.scrollTop > 10);
    document.addEventListener('scroll', onScroll, { passive: true });
    onScroll(); // apply immediately in case page loads already scrolled

    // Toggle main nav
    headerToggle?.addEventListener('click', e => {
        e.preventDefault();
        closeAllSubMenus();

        headerToggle.classList.toggle('nav-open');
        header.classList.toggle('nav-open');

        headerToggle.setAttribute('aria-expanded', headerToggle.classList.contains('nav-open'));
        document.querySelectorAll('.menu-item-has-children.sub-nav-open')
            .forEach(el => el.classList.remove('sub-nav-open'));

        if (headerToggle.classList.contains('nav-open')) {
            document.querySelector('body').classList.add('screen-lock')
        } else {
            document.querySelector('body').classList.remove('screen-lock')
        }
    });

    // Toggle submenus
    carets.forEach(caret => {
        caret.addEventListener('click', e => {
            e.preventDefault();
            const parentLi = caret.closest('li');
            const submenu = caret.nextElementSibling;

            if (parentLi.classList.contains('active')) {
                parentLi.classList.remove('active');
                submenu.style.maxHeight = null;
                caret.querySelectorAll('*').forEach(icon => {
                    icon.style.transform = 'rotate(0deg)';
                });
            } else {
                closeAllSubMenus();
                parentLi.classList.add('active');
                submenu.style.maxHeight = submenu.scrollHeight + 'px';
                caret.querySelectorAll('svg').forEach(icon => {
                    icon.style.transform = 'rotate(180deg)';
                });
            }
        });
    });
});

// Video background poster fade-out
(function () {
    // Native <video>: fade poster once playback starts
    document.querySelectorAll('.bb-hero__video-bg[data-video-type="native"]').forEach(function (bg) {
        var poster = bg.querySelector('.bb-hero__video-poster');
        var video = bg.querySelector('video');
        if (!poster || !video) return;
        video.addEventListener('playing', function handler() {
            poster.classList.add('is-loaded');
            video.removeEventListener('playing', handler);
        });
    });

    // Vimeo iframe: subscribe to play event via postMessage (no SDK needed)
    document.querySelectorAll('.bb-hero__video-bg[data-video-type="vimeo"]').forEach(function (bg) {
        var poster = bg.querySelector('.bb-hero__video-poster');
        var iframe = bg.querySelector('iframe');
        if (!poster || !iframe) return;

        iframe.addEventListener('load', function () {
            iframe.contentWindow.postMessage(
                JSON.stringify({ method: 'addEventListener', value: 'play' }),
                'https://player.vimeo.com'
            );
        });

        window.addEventListener('message', function handler(e) {
            if (e.origin !== 'https://player.vimeo.com' || e.source !== iframe.contentWindow) return;
            try {
                var data = JSON.parse(e.data);
                if (data.event === 'play') {
                    poster.classList.add('is-loaded');
                    window.removeEventListener('message', handler);
                }
            } catch (_) { }
        });
    });
})();

// Parallax
(function () {
    var els = Array.prototype.slice.call(document.querySelectorAll('[data-parallax]'));
    if (!els.length) return;

    var items = els.map(function (el) {
        var s = parseFloat(el.getAttribute('data-parallax'));
        if (!isFinite(s)) s = 0.12; // default
        return { el: el, speed: s };
    });

    var mq = window.matchMedia('(prefers-reduced-motion: reduce)');
    var ticking = false;

    function update() {
        ticking = false;

        if (mq.matches) {
            items.forEach(function (it) { it.el.style.setProperty('--py', '0px'); });
            return;
        }

        var vh = window.innerHeight || document.documentElement.clientHeight;

        items.forEach(function (it) {
            var r = it.el.getBoundingClientRect();
            var progress = (vh - r.top) / (vh + r.height);
            var offset = (progress - 0.5) * r.height * it.speed;
            it.el.style.setProperty('--py', offset.toFixed(2) + 'px');
        });
    }

    function onScrollOrResize() {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(update);
        }
    }

    requestAnimationFrame(update);
    window.addEventListener('scroll', onScrollOrResize, { passive: true });
    window.addEventListener('resize', onScrollOrResize, { passive: true });
    window.addEventListener('orientationchange', onScrollOrResize);

    function applyMotionPref(e) {
        if (e.matches) {
            items.forEach(function (it) { it.el.style.setProperty('--py', '0px'); });
        } else {
            requestAnimationFrame(update);
        }
    }
    applyMotionPref(mq);
    //some of this syntax is to avoid IDE errors
    if (typeof mq.addEventListener === 'function') {
        mq.addEventListener('change', applyMotionPref);
    } else if (typeof mq.addListener === 'function') {
        mq.addListener(applyMotionPref);
    }
})();